import { create } from 'zustand'

interface ModalElInformadorState {
  modalElInformador: {
    isOpen: boolean
    onSuccess?: () => void
  }
  setModalElInformador: (modalElInformador: {
    isOpen: boolean
    onSuccess?: () => void
  }) => void
  reset: () => void
}

const initialState = {
  modalElInformador: {
    isOpen: false
  }
}

export const useModalElInformadorStore = create<ModalElInformadorState>()(
  (set) => ({
    ...initialState,
    setModalElInformador: (modalElInformador) => set({ modalElInformador }),
    reset: () =>
      set({
        modalElInformador: initialState.modalElInformador
      })
  })
)
